import { useEffect } from 'react';
import { useData } from '@/context/DataContext';

export default function ServicesPage() {
  const { fetchContent, getContentBySection, loading } = useData();

  useEffect(() => {
    fetchContent('services');
  }, [fetchContent]);

  const introContent = getContentBySection('services', 'intro');
  const conditionsContent = getContentBySection('services', 'conditions');
  const privateServicesContent = getContentBySection('services', 'private_services');
  const methodsContent = getContentBySection('services', 'methods');
  const ablaufContent = getContentBySection('services', 'ablauf');
  const therapyTypesContent = getContentBySection('services', 'therapy_types');
  const costsGkvContent = getContentBySection('services', 'costs_gkv');
  const costsPkvContent = getContentBySection('services', 'costs_pkv');
  const costsSelfContent = getContentBySection('services', 'costs_self');

  const conditionItems = (conditionsContent?.content || '').split('|').filter(Boolean);
  const privateServiceItems = (privateServicesContent?.content || '').split('|').filter(Boolean);
  const ablaufItems = (ablaufContent?.content || '').split('|').filter(Boolean);
  const therapyTypeItems = (therapyTypesContent?.content || '').split('|').filter(Boolean);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="bg-white" data-testid="services-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-normal text-[#2c3e50] text-center mb-8">Therapieangebote</h1>

        <p className="text-[#2c3e50] text-center mb-12 leading-relaxed">
          {introContent?.content}
        </p>

        {/* Conditions */}
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <h2 className="text-xl font-semibold text-[#2c3e50] mb-4">
              Meine Arbeitsschwerpunkte
            </h2>
            <ul className="space-y-2 text-[#2c3e50]">
              {conditionItems.map((item, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <img 
              src="https://psychotherapie-praxis-langer.de/Bilder/IMG_4879.jpg"
              alt="Praxis"
              className="w-full rounded shadow-md"
            />
          </div>
        </div>

        <hr className="my-8 border-gray-300" />

        {/* Private Services */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-[#2c3e50] mb-4">Privatleistungen</h2>
          <ul className="space-y-2 text-[#2c3e50]">
            {privateServiceItems.map((item, idx) => (
              <li key={idx} className="flex items-start">
                <span className="mr-2">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Methods */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-[#2c3e50] mb-4">Methoden</h2>
          <p className="text-[#2c3e50] leading-relaxed">{methodsContent?.content}</p>
        </div>

        <hr className="my-8 border-gray-300" />

        {/* Ablauf */}
        <div className="mb-12">
          <h2 className="text-2xl font-semibold text-[#2c3e50] mb-6 text-center">Ablauf</h2>
          <div className="space-y-4 text-[#2c3e50]">
            {ablaufItems.map((item, idx) => {
              const isTitle = item === item.toUpperCase() && item.length < 50;
              if (isTitle) {
                return (
                  <h3 key={idx} className="text-lg font-semibold text-[#3498db] mt-6">
                    {item}
                  </h3>
                );
              }
              return <p key={idx} className="leading-relaxed">{item}</p>;
            })}
          </div>
        </div>

        <div className="mb-12 space-y-3 text-[#2c3e50]">
          {therapyTypeItems.map((item, idx) => (
            <p key={idx} className="leading-relaxed">{item}</p>
          ))}
        </div>

        <hr className="my-8 border-gray-300" />

        {/* Costs */}
        <h2 className="text-2xl font-semibold text-[#2c3e50] mb-6 text-center">Kostenübernahme</h2>
        
        <div className="space-y-8">
          <div>
            <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">
              {costsGkvContent?.title}
            </h3>
            <p className="text-[#2c3e50] leading-relaxed">{costsGkvContent?.content}</p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">
              {costsPkvContent?.title}
            </h3>
            <p className="text-[#2c3e50] leading-relaxed">{costsPkvContent?.content}</p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">
              {costsSelfContent?.title}
            </h3>
            <p className="text-[#2c3e50] leading-relaxed">{costsSelfContent?.content}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
